import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import SaleOrderRequestFileLine from '../entities/sale-order-file-line'
import Ajax from '../../lib/ajax'
import util from '@/lib/util';
import _ from 'lodash';
import PageResult from '@/store/entities/page-result';
import appconst from './../../lib/appconst';

interface SaleOrderRequestImportState extends ListState<SaleOrderRequestFileLine> {
    itemsImported: Array<SaleOrderRequestFileLine>,
    countItems: number,
    countImportedItems: number
}
class SaleOrderRequestImportModule extends ListModule<SaleOrderRequestImportState, any, SaleOrderRequestFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<SaleOrderRequestFileLine>(),
        loading: false,
        itemsImported: new Array<SaleOrderRequestFileLine>(),
        countItems: 0,
        countImportedItems: 0
    }
    actions = {
        async getAll(context: ActionContext<SaleOrderRequestImportState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/SoRequestFileLine/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async uploadImportSaleOrderRequestFile(context: ActionContext<SaleOrderRequestImportState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/SoRequestFile/ImportSoRequests', data);
            return reponse.data.result;
        },
        async export(context:ActionContext<SaleOrderRequestImportState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportSoRequests/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: SaleOrderRequestImportState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SaleOrderRequestImportState, pagesize: number) {
           
            state.pageSize = pagesize;
        },
        setCountItems(state: SaleOrderRequestImportState, count: number) {
            state.countItems = count;
        },
        setCountImportedItems(state: SaleOrderRequestImportState, count: number) {
            state.countImportedItems = count;
        },
        processNotifier(state: SaleOrderRequestImportState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    const sorLines = payload.data.data as Array<SaleOrderRequestFileLine>;
                    state.list = sorLines;
                }
                if (!util.isNull(payload.data.countLine) && payload.data.countLine > 0) {
                    state.totalCount = payload.data.countLine as number;
                    state.currentPage = 1;
                }
                if (payload.data.countSoRequest != undefined && payload.data.countSoRequest != null && payload.data.countSoRequest > 0) {
                    state.countItems = payload.data.countSoRequest as number;
                }
                if (payload.data.soRequestImported != undefined && payload.data.soRequestImported != null && payload.data.soRequestImported> 0) {
                    state.countImportedItems = payload.data.soRequestImported as number;
                }
            }
        },
        resetList(state: SaleOrderRequestImportState) {
            state.itemsImported = new Array<SaleOrderRequestFileLine>();
        },
        pageChangeItemsImported(state: SaleOrderRequestImportState) {
            state.list = util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
        }
    }
}
const saleOrderRequestImportModule = new SaleOrderRequestImportModule();
export default saleOrderRequestImportModule;